"use client";

import { Header } from "@/components/header";
import { Button } from "@/components/ui/button";
import { Home, RotateCcw } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
import { getCurrentRole } from "@/features/firebase/auth/actions/getCurrentRole";

// 例外時のフォールバック。強制ログアウトはせず、再読み込みとロールホームへの導線を出す。
// 未ログイン時のみログインページへ誘導する。
export default function Error({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [home, setHome] = useState<{ path: string; prefix: string }>({
    path: "/login",
    prefix: "/login",
  });

  useEffect(() => {
    getCurrentRole()
      .then((role) => {
        if (role === "ADMIN") setHome({ path: "/admin/summary", prefix: "/admin" });
        else if (role === "AGENT USER") setHome({ path: "/a/top/new", prefix: "/a" });
        else if (role === "COMPANY USER") setHome({ path: "/c/top/new", prefix: "/c" });
        else setHome({ path: "/login", prefix: "/login" });
      })
      .catch(() => setHome({ path: "/login", prefix: "/login" }));
  }, []);

  const isLoggedIn = home.path !== "/login";

  return (
    <>
      <Header title="" prefix={home.prefix} />
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full text-center p-6">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">エラーが発生しました</h1>
            <p className="text-gray-600 mb-8">
              一時的な問題が発生しました。お手数ですが再度お試しください。
            </p>
          </div>
          <div className="space-y-4">
            <Button
              onClick={() => reset()}
              className="w-full bg-red-500 hover:bg-red-600 text-white"
              size="lg"
            >
              <RotateCcw className="mr-2 h-5 w-5" />
              再読み込み
            </Button>
            <Link href={home.path}>
              <Button variant="outline" className="w-full" size="lg">
                <Home className="mr-2 h-5 w-5" />
                {isLoggedIn ? "ホームページに戻る" : "ログインページへ移動"}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
